// TelcoTrack — Nastavení aplikace. Saved profile `sections.app-settings.view`.

import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from '../services/auth.service';
import { permissionAllows } from '@core/shared-bridge';

export const adminGuard: CanActivateFn = () => {
  const authService = inject(AuthService);
  const router = inject(Router);
  const user = authService.getCurrentUser();
  if (permissionAllows(user?.permissionProfile, 'app-settings', 'view')) {
    return true;
  }
  return router.createUrlTree(['/403']);
};
